/**
 * Toggles product card primary/secondary images (lamp on/off) on collection pages.
 * Uses the same opacity swap as product-card hover.
 * Switch transition: 0.7s / Hover transition: 0.3s
 */
class LampImageToggle extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input[type="checkbox"]');
    this.list = document.getElementById(this.getAttribute('aria-controls'));
    this.switchTimeout = null;

    if (!this.input || !this.list) return;

    this.input.addEventListener('change', this.sync.bind(this));
    this.list.setAttribute('data-lamp-state', this.input.checked ? 'on' : 'off');
  }

  disconnectedCallback() {
    clearTimeout(this.switchTimeout);
  }

  sync() {
    clearTimeout(this.switchTimeout);
    this.list.classList.add('is-switching');
    this.list.setAttribute('data-lamp-state', this.input.checked ? 'on' : 'off');

    this.switchTimeout = setTimeout(() => {
      this.list.classList.remove('is-switching');
    }, 700);
  }
}

if (!window.customElements.get('lamp-image-toggle')) {
  window.customElements.define('lamp-image-toggle', LampImageToggle);
}
